import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import constant from '../../../app.constant'
import { HeaderService } from 'src/app/service/header.service';
import { LocalStorageService } from '../../../utils/local-storage.service';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {

  public iconSidebar;
  public menuItems: Menu[];
  public url: any;
  public fileurl: any;
  // For Horizontal Menu
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;
  public logoUrl: any;
  public logoIcon: any;
  userDetails: any = {};
  constructor(private router: Router, public navServices: NavService, public headerService: HeaderService, public localStorageservice: LocalStorageService,
    public layout: LayoutService) {
    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter(items => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) { return false; }
            items.children.filter(subItems => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) { return false; }
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
            });
          });
        }
      });
    });

    // setTimeout(() => {
    //   let newDate = moment().format('x');
    //   if (['assets/images/logo/logo.png'].includes(this.localStorageservice.getItem(constant.localStorage.logo_url))) {
    //     this.logoUrl = 'assets/images/logo/logo.png'
    //   } else {
    //     this.logoUrl = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.logo_url) + '&clr=' + newDate;
    //   }
    //   if (['assets/images/logo/logo-icon.png'].includes(this.localStorageservice.getItem(constant.localStorage.icon_url))) {
    //     this.logoIcon = 'assets/images/logo/logo-icon.png';
    //   } else {
    //     this.logoIcon = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.localStorageservice.getItem(constant.localStorage.icon_url) + '&clr=' + newDate
    //   }

    // }, 2000);
  }




  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  // Active Nave state
  setNavActive(item) {
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }


  // For Horizontal Menu
  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }


}
